import { getID } from "src/libs/utilities"

 

const icon = (): any[] => {
    return [
        {
            "type": "icon",
            "id": getID( "icon" ),
            "src": "fas fa-home",
            size: 33,
            "style": {
                "fontSize": 33
            },
            defaultTitle: "Иконка"
        }
    ]
}

export default icon